import { DOCUMENT_CONTROL_PANEL_HEIGHT } from 'constants/documents';
import { MODAL_BODY_DEFAULT_OFFSETS } from 'constants/ui';

export const documentViewWrapperStyles = {
  width: '100%',
  overflow: 'hidden',

  '& .document_view__document_pages_wrapper': {
    maxHeight: `calc(100vh - ${DOCUMENT_CONTROL_PANEL_HEIGHT + MODAL_BODY_DEFAULT_OFFSETS}px)`,
  },
};

// A definite-height column lets the viewer take whatever the banner leaves, however many lines the banner wraps to.
export const documentViewWithBannerWrapperStyles = {
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  height: `calc(100vh - ${MODAL_BODY_DEFAULT_OFFSETS}px)`,

  '& > :last-child': {
    flex: 1,
    minHeight: 0,
  },
};
